import React, { useState, useEffect } from 'react';
import DashNavbar from './DashNavbar';
import StudentsTable from './StudentsTable';
import './style/Dashboard.css';
import AddStudentModal from './AddStudentModal';
import AddTeacherModal from './AddTeacherModal'; // Import AddTeacherModal
import CardComponent from './CardComponent';
import useStudentData from './useStudentData';
import AmountQueryModal from './AmountQueryModal';
import { handleAddStudent, handleDeleteStudent, handleQueryAmount, validateToken, handleAddTeacher } from './StudentAPI';
import DownloadTransactionsModal from './DownloadTransactionsModal';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
    const [showStudentModal, setShowStudentModal] = useState(false);
    const [showTeacherModal, setShowTeacherModal] = useState(false);
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showQueryModal, setShowQueryModal] = useState(false);
    const [showArchived, setShowArchived] = useState(false);
    const PROTOCOL = process.env.REACT_APP_LOGIN_PROTOCOL;
    const HOST_NAME = process.env.REACT_APP_LOGIN_HOST;
    const backendURL = `${PROTOCOL}://${HOST_NAME}`;
    const { data, students, fetchAllStudents } = useStudentData(backendURL);
    const navigate = useNavigate();

    const onAddStudent = (name, phoneNumber, email) => {
        handleAddStudent(name, phoneNumber, email, fetchAllStudents);
    };

    const onAddTeacher = (name) => {
        handleAddTeacher(name, fetchAllStudents); // Call handleAddTeacher
    };

    const onDeleteStudent = async (studentId, studentName) => {
        handleDeleteStudent(studentId, studentName, fetchAllStudents);
    };

    const handleValidateToken = async (token) => {
        const success = await validateToken(token);
        if (!success) {
            console.log('Invalid token');
            localStorage.removeItem('token');
            navigate('/login');
        }
    };

    const onQueryAmount = async (startDate, endDate, queryType) => {
        const result = await handleQueryAmount(startDate, endDate, queryType);
        return result;
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            handleValidateToken(token);
        } else {
            navigate('/login');
        }
    }, [navigate]);

    const filteredStudents = students.filter(student => showArchived || !student.archived);

    return (
        <div>
            <DashNavbar />
            <div className="container mt-5 dashboard">
                <div className="row">
                    <CardComponent title="Total Students" value={data.totalStudents} />
                    <CardComponent title="Total Due" value={data.totalDue} unit="$" />
                    <CardComponent title="Total Paid" value={data.totalPaid} unit="$" />
                    <CardComponent title="Total Unpaid Due" value={data.totalUnpaidDue} unit="$" />
                </div>

                <button className="btn btn-primary mt-4" onClick={() => setShowStudentModal(true)}>
                    Add Student
                </button>

                <button className="btn btn-secondary mt-4 ml-2" onClick={() => setShowArchived(!showArchived)}>
                    {showArchived ? 'Hide Archived' : 'Show Archived'}
                </button>

                <button className="btn btn-primary mt-4 ml-2" onClick={() => setShowTeacherModal(true)}>
                    Add Teacher
                </button>

                <button className="btn btn-info mt-4 ml-2" onClick={() => setShowQueryModal(true)}>
                    Query Amount
                </button>

                <button className="btn btn-success mt-4 ml-2" onClick={() => setShowDownloadModal(true)}>
                    Download Transactions
                </button>

                <StudentsTable
                    students={filteredStudents}
                    onDeleteStudent={onDeleteStudent}
                    fetchAllStudents={fetchAllStudents}
                    showArchived={showArchived}
                />

                <AddStudentModal 
                    showModal={showStudentModal} 
                    onClose={() => setShowStudentModal(false)} 
                    onAddStudent={onAddStudent} 
                />

                <AddTeacherModal
                    showModal={showTeacherModal}
                    onClose={() => setShowTeacherModal(false)}
                    onAddTeacher={onAddTeacher}
                />

                <DownloadTransactionsModal
                    showModal={showDownloadModal}
                    onClose={() => setShowDownloadModal(false)}
                />

                <AmountQueryModal
                    showModal={showQueryModal}
                    onClose={() => setShowQueryModal(false)}
                    onQuery={onQueryAmount}
                />
            </div>
        </div>
    );
}

export default Dashboard;
